import { useGridApiRef } from "@mui/x-data-grid";
import { useRef } from "react";

export const useDataGridState = () => {
  const apiRef = useGridApiRef();
  const activeFieldRef = useRef("");
  const hasRenderedOnce = useRef(false);
  const hasSetInitialQuickFilterRef = useRef(false);
  const isUpdatingQuickFilterRef = useRef(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  return {
    apiRef,
    activeFieldRef,
    hasRenderedOnce,
    hasSetInitialQuickFilterRef,
    isUpdatingQuickFilterRef,
    timeoutRef
  };
};
